import React, { useState, useEffect } from "react";
import {
  Layout,
  Card,
  Space,
  DatePicker,
  Select,
  Button,
  Table,
  message,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import Chat from "../../components/chats/Chat";

const { Content } = Layout;
const { RangePicker } = DatePicker;

const SessionReports = ({ handleColorChange }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // const [fromDate, setFromDate] = useState(new Date("2024-10-01T00:00:00"));
  // const [toDate, setToDate] = useState(new Date("2024-10-31T23:59:59.999"));
  const [fromDate, setFromDate] = useState(() => {
    const now = new Date();
    const firstOfMonth = new Date(
      now.getFullYear(),
      now.getMonth(),
      1,
      0,
      0,
      0,
      0,
    );
    return firstOfMonth;
  });
  const [chatBoxOpen, setChatOpen] = useState(false);

  const [toDate, setToDate] = useState(() => {
    const today = new Date();
    today.setHours(23, 59, 59, 999); // Set to end of today

    return today;
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);

  const [dateRange, setDateRange] = useState([
    moment().subtract(15, "days").startOf("day"),
    moment().endOf("day"),
  ]);
  const token = useSelector((state) => state.userAuth.token);

  useEffect(() => {
    if (handleColorChange) {
      handleColorChange("#000833");
    }
    fetchData();
  }, []);

  const columns = [
    {
      title: "Session ID",
      dataIndex: "session_id",
      key: "session_id",
      width: 150,
    },
    {
      title: "User Email",
      dataIndex: "user_email",
      key: "user_email",
      width: 180,
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
      width: 150,
    },
    {
      title: "Account Number",
      dataIndex: "acct_ids",
      key: "acct_ids",
      width: 250,
      render: (text) => (
        <div
          style={{
            maxWidth: 220,
            overflowX: "auto",
            whiteSpace: "nowrap",
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE/Edge
          }}
          className="hide-column-scroll"
        >
          {text
            ?.split(",")
            .map((item) => item.trim())
            .join(", ")}
        </div>
      ),
    },
    {
      title: "Login Time",
      dataIndex: "login_time",
      key: "login_time",
      width: 150,
      render: (text) => moment(text).format("MM-DD-YYYY HH:mm:ss"),
    },
    {
      title: "Logout Time",
      dataIndex: "logout_time",
      key: "logout_time",
      width: 150,
      render: (text) =>
        text ? moment(text).format("MM-DD-YYYY HH:mm:ss") : "-",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
      width: 150,
    },
    {
      title: "Device Type",
      dataIndex: "device_type",
      key: "device_type",
      width: 150,
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      width: 150,
    },
  ];

  const fetchData = async (
    page = pagination.current,
    pageSize = pagination.pageSize,
    firstDate,
    lastDate,
  ) => {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (fromDate > toDate || firstDate > lastDate) {
      message.error("Please choose valid Dates");
      return;
    }
    if (toDate > today) {
      message.error("Please enter valid Date");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      // const [startDate, endDate] = dates || [];
      const response = await axiosInstance.get(`/users/sessions`, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
        params: {
          page,
          limit: pageSize,
          // startDate: startDate?.format('YYYY-MM-DD'),
          // endDate: endDate?.format('YYYY-MM-DD')
          // startDate:fromDate,
          // endDate:endDate
          startDate: firstDate || fromDate,
          endDate: lastDate || toDate,
        },
      });

      const responseData = response.data.data;
      setData(responseData.data || []);
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: responseData.total || 0,
      });
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize, fromDate, toDate);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const handleFilter = () => {
    fetchData(1, pagination.pageSize, fromDate, toDate);
  };

  const handleExport = async () => {
    try {
      const token = localStorage.getItem("token");
      // const [startDate, endDate] = dateRange || [];
      const response = await axiosInstance.get(`/users/sessions`, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
        params: {
          format: "excel",
          startDate: fromDate,
          endDate: toDate,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `session_report_${moment().format("MM-DD-YYYY")}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting sessions:", error);
    }
  };

  const exportSessionReport = async () => {
    try {
      const response = await axiosInstance.get(
        `/users/sessions/export?startDate=${fromDate}&endDate=${toDate}`,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `session_report_${moment().format("YYYY-MM-DD")}.xlsx`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting session report:", error);
    }
  };

  return (
    <>
      <HeaderCompo initialColor={"#000833"} />

      <div style={{ padding: "24px" }}>
        <Card title="Session Reports" className="custom-card">
          <div
            style={{ marginBottom: 16 }}
            className="flex flex-col items-start md:flex-row gap-x-4 w-full gap-y-4"
          >
            <div className="flex gap-x-3 ">
              <div className="flex gap-1 justify-center align-middle">
                {/* <span className="font-medium text-gray-600">From</span> */}
                <DatePicker
                  format="MM-DD-YYYY"
                  placeholder="From Date"
                  value={fromDate ? dayjs(fromDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const jsDate = new Date(date.toDate());
                      jsDate.setHours(0, 0, 0, 0);
                      setFromDate(jsDate);
                    }
                  }}
                  className="w-full md:w-[160px]"
                />
              </div>
              <div className="flex flex-row gap-1 justify-center align-middle">
                {/* <span className=" font-medium text-gray-600">To</span> */}
                <DatePicker
                  placeholder="To Date"
                  value={toDate ? dayjs(toDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const jsDate = new Date(date.toDate());
                      jsDate.setHours(23, 59, 59, 999);
                      setToDate(jsDate);
                    }
                  }}
                  format="MM-DD-YYYY"
                  className="w-full md:w-[160px]"
                />
              </div>
              <Button type="primary" onClick={handleFilter}>
                Apply Filter
              </Button>
            </div>
            <div className="w-full">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={exportSessionReport}
                className="w-full md:w-[100px] bg-[#0EA5E9]  hover:bg-[#0EA5E9]/90"
              >
                Export
              </Button>
            </div>
          </div>

          <div
            style={{
              overflowX: "auto",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE/Edge
            }}
          >
            <Table
              columns={columns}
              dataSource={data}
              pagination={{
                ...pagination,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} items`,
              }}
              loading={loading}
              onChange={handleTableChange}
              rowKey="session_id"
              scroll={{ x: "max-content" }}
            />
          </div>
        </Card>
        {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
          <div className="chat-button" onClick={() => setChatOpen(true)}>
            💬 Let’s Chat
          </div>
        )} */}
        <Chat open={chatBoxOpen} setOpen={setChatOpen} />
      </div>
      <style>
        {`
      .hide-column-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.hide-column-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}`}
      </style>
    </>
  );
};

export default SessionReports;